import axios from "axios";
import store from "./redux/store";

// subscribe to API location changes so we can update the axios baseURL
store.subscribe(() => {
  if (client.defaults.baseURL !== store.getState().setting.apiLocation) {
    client.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/uks";
  }
  if (notificationClient.defaults.baseURL !== store.getState().setting.apiLocation) {
    notificationClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/notificationservice";
  }
  if (jobClient.defaults.baseURL !== store.getState().setting.apiLocation) {
    jobClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/jobservice";
  }
  if (contentClient.defaults.baseURL !== store.getState().setting.apiLocation) {
    contentClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/contentservice";
  }
  if (
    attachmentClient.defaults.baseURL !== store.getState().setting.apiLocation
  ) {
    attachmentClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/attachmentservice";
  }
  if (reportClient.defaults.baseURL !== store.getState().setting.apiLocation) {
    reportClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/reportservice";
  }
  if (
    discussionClient.defaults.baseURL !== store.getState().setting.apiLocation
  ) {
    discussionClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/discussionservice";
  }
  if (
    taxServiceClient.defaults.baseURL !== store.getState().setting.apiLocation
  ) {
    taxServiceClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/taxonomyservice";
  }
  if (
    authServiceClient.defaults.baseURL !== store.getState().setting.apiLocation
  ) {
    authServiceClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/authservice";
  }
  if (
    anonAuthServiceClient.defaults.baseURL !==
    store.getState().setting.apiLocation
  ) {
    anonAuthServiceClient.defaults.baseURL =
      "https://" + store.getState().setting.apiLocation + "/authservice";
  }
});

export const jobClient = axios.create({
  withCredentials: true,
});
export const contentClient = axios.create({
  withCredentials: true,
});
export const reportClient = axios.create({
  withCredentials: true,
});
export const discussionClient = axios.create({
  withCredentials: true,
});
export const taxServiceClient = axios.create({
  withCredentials: true,
});
export const authServiceClient = axios.create({
  withCredentials: true,
});
export const attachmentClient =axios.create({
  withCredentials: true,
});
export const notificationClient =axios.create({
  withCredentials: true,
});
export const anonAuthServiceClient = axios.create();
const client = axios.create({
  withCredentials: true,
});
export default client;
